module.exports = __webpack_public_path__ + "img/appdownload.aa38db2d.png";